module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_06-d381a956223b18e8f19015c096d56caf.jpg";